import React, { useEffect, useRef } from "react";
import L from "leaflet";
import "leaflet/dist/leaflet.css";
import { useNavigate } from "react-router-dom"; // React Router (kept for potential use, but using prop for selection)

const MapComponent = ({ products = [], onSelectDevice }) => { // Accept products prop for dynamic markers
  const mapRef = useRef(null);
  const navigate = useNavigate();

  // City coordinates mapping (lat, lng) for diverse locations in India
  const cityCoords = {
    "Chennai, India": [13.0827, 80.2707],
    "Mumbai, India": [19.0760, 72.8777],
    "Delhi, India": [28.6139, 77.2090],
    "Bangalore, India": [12.9716, 77.5946],
    "Kolkata, India": [22.5726, 88.3639],
    "Hyderabad, India": [17.3850, 78.4867],
    "Pune, India": [18.5204, 73.8567]
  };

  useEffect(() => {
    if (mapRef.current && mapRef.current._leaflet_id) return;

    mapRef.current = L.map("map").setView([20.5937, 78.9629], 5); // Center on India

    L.tileLayer("https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png", {
      maxZoom: 10, // Increased for city-level zoom
      attribution: "&copy; OpenStreetMap contributors",
    }).addTo(mapRef.current);

    // Generate markers from products prop
    products.forEach((product) => {
      const [lat, lng] = cityCoords[product.location] || [20.5937, 78.9629]; // Fallback to India center
      const markerColor = product.status === "online" ? "green" : "red";

      const marker = L.circleMarker([lat, lng], {
        color: markerColor,
        radius: 8,
        fillOpacity: 0.8,
      }).addTo(mapRef.current);

      marker.bindPopup(
        `<b>${product.location} - ${product.id}</b><br>Client: ${product.client}<br>Status: <span style='color:${markerColor};'>${product.status}</span>`
      );

      marker.on("click", () => {
        // Use the prop callback to select device (like handleViewDevice in table)
        if (onSelectDevice) {
          onSelectDevice(product);
        } else {
          // Fallback to navigate if no prop
          navigate("/dashboard");
        }
      });
    });
  }, [products, navigate, onSelectDevice]); // Depend on products for re-render if they change

  return <div id="map" style={{ height: "100%", width: "100%", position: "relative", zIndex: "0" }}></div>;
};

export default MapComponent;